<template>
  <a-card :bordered="false" title="在线调试">
    <div>
      <span style="margin-right:20px">生产环境地址:</span>
      <a @click="openNewPage(form.productionEnvironmentUrl)">{{ form.productionEnvironmentUrl }}</a>
    </div>
    <div style="margin-top:20px;margin-bottom:57%;">
      <span style="margin-right:20px">沙箱环境地址:</span>
      <a @click="openNewPage(form.sandboxEnvironmentUrl)">{{ form.sandboxEnvironmentUrl }}</a>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'OnlineDebugging',
  data() {
    return {
      form: {}
    }
  },
  mounted() {
    this.getOnlineDebugging()
  },
  methods: {
    getOnlineDebugging() {
      this.getHttpServices()
        .getServerApiService()
        .post('directAssistant/search/getOnlineDebugging')
        .then(res => {
          this.form = res
        })
        .catch(reason => {
          console.error('getOnlineDebugging', reason)
        })
    },
    openNewPage(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
